import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "@emotion/react";

import materialUITheme from "./theme";
import { defaultTheme } from "./emotion-theme";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";

// Sentry Documentation:
// https://docs.sentry.io/platforms/javascript/guides/react/
if (process.env.SENTRY_PUBLIC_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_PUBLIC_DSN,
    release: `otis-fe${process.env.npm_package_version}`,
    // Leaving out APM sampling for now
    // If adding later, add `import { Integrations } from "@sentry/tracing";` to the file imports
    // See also: https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    // integrations: [
    //   new Integrations.BrowserTracing({
    //     routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    //   }),
    // ],
    // tracesSampleRate: 0.25, // send  25% of transactions to Sentry
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <StylesProvider injectFirst={true}>
        <MuiThemeProvider theme={materialUITheme}>
          <CssBaseline />
          <ThemeProvider theme={defaultTheme}>
            <App />
          </ThemeProvider>
        </MuiThemeProvider>
      </StylesProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
